import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-header" }, "Política de cancelamento")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Sessões pagas via boleto não podem ser canceladas. No entanto, é possível realizar o reagendamento, se necessário. ", -1)

import { computed, ref } from "vue";
import type { Appointment } from "@phurshell/psiapp-frontend-core/domain";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { cancellationSchema } from "@/schemas/appointment";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";
import { syncSession } from "@/di/useCases";
import { useUpdateAppointment, useInvalidateAppointments } from "@/composables/useAppointments";
import { closeOffCanvas } from "@/views/OffcanvasViews/OffcanvasViewsConfig";

const modalId = "cancel_appointment_modal";

export default /*#__PURE__*/_defineComponent({
  __name: 'Cancellation',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

const submitting = ref(false);

const cancelAllOptions = [
  { id: false, title: "Somente esta sessão" },
  { id: true, title: "Esta sessão e as próximas" },
];

const { handleSubmit, meta } = useForm({
  validationSchema: toTypedSchema(cancellationSchema),
  initialValues: { reason_for_cancellation: "", cancel_all: false },
});

const reasonForCancellationModel = useVeeField("reason_for_cancellation");
const cancelAllModel = useVeeField("cancel_all");

const isCancelable = computed(
  () => props.item.status === "agendado" && !props.item.is_waiting_boleto_payment
);

const modalTitle = computed(() =>
  props.item.recurrency
    ? "Qual sessão você deseja cancelar?"
    : "Tem certeza que deseja cancelar esta sessão?"
);

const { mutateAsync: updateAppointment } = useUpdateAppointment();
const invalidateAppointments = useInvalidateAppointments();

const handleCancelConfirmed = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    const params: any = {
      status: props.item.status === "agendado" ? "cancelado" : "recusado",
      reason_for_cancellation: values.reason_for_cancellation,
    };

    if (values.cancel_all) {
      params.cancel_recurrency = true;
    }

    await updateAppointment({ id: props.item.id, ...params });
    await syncSession.execute();

    if (props.item.status === "pendente") {
      closeOffCanvas();
      return;
    }

    toggleModal(modalId);
    EventBus.$emit(EventBusNames.UPDATE_APPOINTMENTS);
  } catch (e) {
    console.log(e);
  } finally {
    submitting.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_RadioInput = _resolveComponent("RadioInput")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FormButton = _resolveComponent("FormButton")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (isCancelable.value)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Cancelar esta sessão",
              fullWidth: "",
              outline: "",
              outlineColor: "danger",
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleModal)(modalId)))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      id: modalId,
      title: modalTitle.value,
      backdrop: "false"
    }, {
      body: _withCtx(() => [
        (_ctx.item.recurrency)
          ? (_openBlock(), _createBlock(_component_RadioInput, {
              key: 0,
              model: _unref(cancelAllModel),
              options: cancelAllOptions
            }, null, 8, ["model"]))
          : _createCommentVNode("", true),
        _createVNode(_component_TextInput, {
          required: "",
          label: "Motivo",
          model: _unref(reasonForCancellationModel),
          placeholder: "Por que deseja cancelar?"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          outline: "",
          outlineColor: "primary",
          label: "Não, voltar",
          onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(toggleModal)(modalId)))
        }),
        _createVNode(_component_FormButton, {
          label: "Sim, cancelar esta sessão",
          color: "danger",
          onOnClick: _unref(handleCancelConfirmed),
          loading: submitting.value,
          disabled: !_unref(meta).valid
        }, null, 8, ["onOnClick", "loading", "disabled"])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}
}

})